import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../styles/components/AfterResultBot.css";
import omnicareLogo from "../../assets/icons/logo.svg";
import doctorImage from "../../assets/images/doctor.png";
import backIcon from "../../assets/icons/back.svg";
import LanguageSwitcher from "../LanguageSwitcher";

const AfterQuiz1 = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState("");

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    if (option === "yes") {
      navigate("/after-quiz/2");
    } else if (option === "no") {
      navigate("/after-quiz/3");
    }
  };

  const handleBack = () => {
    navigate("/results");
  };

  return (
    <div className="after-result-bot-container">
      {/* Header - reusing exact same structure as SurveyTemplate */}
      <header className="after-result-bot-header">
        <div className="logo-section">
          <div className="logo" onClick={() => navigate("/landing")} style={{ cursor: 'pointer' }}>
            <img src={omnicareLogo} alt="Pebble Health Logo" className="logo-icon" />
            <span className="logo-text">Pebble Health</span>
          </div>
        </div>
        <div className="header-actions">
          <LanguageSwitcher />
          <div className="back-button" onClick={handleBack}>
            <img src={backIcon} alt="Back" className="back-icon" />
          </div>
        </div>
      </header>

      {/* Doctor illustration positioned on the divider line - same as SurveyTemplate */}
      <div className="doctor-divider">
        <img src={doctorImage} alt="Dr. Sam" className="doctor-avatar" />
      </div>

      <div className="after-result-bot-content">
        {/* Main Question Section */}
        <div className="question-section">
          <h2 className="question-text">{t("afterQuiz.step1.question")}</h2>
          
          <div className="options-container">
            <button
              className={`option-button ${
                selectedOption === "yes" ? "selected" : ""
              }`}
              onClick={() => handleOptionSelect("yes")}
            >
              <span>{t("afterQuiz.step1.yes")}</span>
            </button>
            <button
              className={`option-button ${
                selectedOption === "no" ? "selected" : ""
              }`}
              onClick={() => handleOptionSelect("no")}
            >
              <span>{t("afterQuiz.step1.no")}</span>
            </button>
          </div>
        </div>
        
        {/* Survey Launcher */}
        <div className="survey-launcher">
          <button
            className="start-survey-button"
            onClick={() => navigate("/survey/1")}
          >
            📋 {t("common.startSurvey")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AfterQuiz1; 